module.exports = __webpack_public_path__ + "res/28-img_business_view_bg.fdbb2900b938f5d4ba30d9eba714d4f5.png";